import * as React from "react"

import { useStory } from "../../context/story-context"
import SearchBar from "./SearchBar"
import Logo from "../../assets/Logo"
import ValidationWarning from "../ValidationWarning"
import AutoCompleteSearch from "../AutoComplete/AutoComplete"

const SearchUI = () => {
  const [data, setData] = React.useState("...")

  // React.useEffect(() => {
  //   async function fetchData() {
  //     const request = await fetch(`https://api.digitalfootprint.earth/stats`)
  //     const data = await request.json()
  //     setData(`${data.auditCount}+`)
  //   }
  //   fetchData()
  // }, [])

  return (
    <>
      <div className="flex flex-col items-center justify-center w-full h-full space-y-3 mt-8">
        <Logo className="h-8 w-8 md:h-12 md:w-12 text-yellow-400" />
        <h1 className="text-2xl md:text-4xl font-bold text-white max-w-xl text-center">
          Translating Digital Footprints into Real World Effects.
        </h1>
        <p className="text-lg font-medium text-white">
          {data} Webpages Analyzed
        </p>
        <div className="relative w-full mx-auto max-w-xl flex flex-col items-center h-64">
          <SearchBar />
        </div>
      </div>
    </>
  )
}

export default SearchUI
